import { GET_VIEWED_FUNCTIONS } from 'actions';
import { FAILURE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponseObject } from 'api/types';
import connectReducers from 'utils/connectReducers';

import { IReducers } from '.';
import genericReducers from './genericReducer';

export type ViewedFunctionsRequestState = ICommonResponseObject<null>;

const initialState: ViewedFunctionsRequestState = {
  content: null,
  loading: false,
};

const generic = genericReducers<ViewedFunctionsRequestState>();

const viewedFunctionsRequest: IReducers<ViewedFunctionsRequestState> = {
  [GET_VIEWED_FUNCTIONS[REQUEST]]: generic.get.request,
  [GET_VIEWED_FUNCTIONS[SUCCESS]]: generic.get.success,
  [GET_VIEWED_FUNCTIONS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, viewedFunctionsRequest);
